import React from 'react'
import img from "../assets/404.png";

const NotFound = () => {
  return (
    <div style={{display: 'flex', alignItems: 'center', justifyContent:'center', flexDirection: 'column'}}>
        <img src={img} style={{objectFit: 'contain', width: 400, height: 400}} alt='page-not-found' />
        <h1 style={{textAlign:'center', color: '#2D2D2D'}}>Page Not Found</h1>
        <div style={{marginTop: 25}} className='subscribe-btn' onClick={() => window.location.replace('/')}><p>Back to home</p></div>
</div>
  )
}

export default NotFound